/* Collectie blauwlicht brillen (WP blauwlicht.1, 20-10-2026). Ontwerp: blauwlicht/ontwerp/v2/collectie-bestanden/bl.js
 * (ronde 3). Geladen door sections/banky-bril-col-boven.liquid (defer). Alles werkt ook zonder dit script: de kaart toont de
 * eerste kleur, de module staat vast op 's Avonds en Oranje glas, de panelen staan open. Toevoegen doet Halo's
 * productformulier (is="product-form") met de gekozen variant (name="id"). Het script voegt toe:
 *  1 kleurkeuze gelijk houden tussen kaart en koopbalk (foto, kleurnaam, naam van de snelknop), het andere kaartbeeld laden
 *    bij interesse
 *  2 de module "Wat het glas tegenhoudt" (moment en glas; de lijn van het spectrum opnieuw tekenen)
 *  3 inklappen op de telefoon (Goed om te weten en de eerste FAQ), een link naar een anker opent het paneel
 *  4 de koopbalk: zichtbaar zodra de kaarten voorbij zijn, weg bij de footer
 * Bij prefers-reduced-motion geen animatie van de grafiek en geen overgangen (CSS). */
(() => {
  'use strict';
  if (window.bankyBrilCollectie) return;
  window.bankyBrilCollectie = {versie: 1};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const html = document.documentElement;
  html.classList.add('bl-js');
  const rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  const telefoon = window.matchMedia('(max-width: 699px)');

  /* 1. Kleurkeuze */
  const kleurRadios = $$('.bl-stalen__radio[data-kleur], .bl-balk__radio[data-kleur]');
  const zetKleur = (kleur, bron) => {
    let naam = '';
    kleurRadios.forEach(r => { if (r.dataset.kleur === kleur) { if (r !== bron && !r.checked) r.checked = true; naam = r.dataset.naam || naam; } });
    $$('[data-kaart-kleur]').forEach(v => { v.hidden = v.dataset.kaartKleur !== kleur; });
    $$('[data-bl-kleurnaam]').forEach(el => { if (naam) el.textContent = naam; });
    $$('[data-bl-snel]').forEach(knop => {
      const basis = (knop.getAttribute('aria-label') || '').replace(/,\s*[^,]*$/, '');
      if (naam && basis) knop.setAttribute('aria-label', `${basis}, ${naam}`);
    });
  };
  kleurRadios.forEach(r => r.addEventListener('change', () => { if (r.checked) zetKleur(r.dataset.kleur, r); }));
  const laadKaart = () => $$('.bl-kaart--bril img[loading="lazy"]').forEach(i => { i.loading = 'eager'; });
  $$('[data-bl-stalen], .bl-balk__montuur').forEach(f => ['pointerenter', 'focusin', 'touchstart'].forEach(t => f.addEventListener(t, laadKaart, {passive: true, once: true})));
  // Een snelknop of koopbalk die bezig is: kort "toegevoegd" tonen (Halo opent de lade)
  document.addEventListener('variant:add', e => {
    const f = e.target && e.target.closest && e.target.closest('form[data-bl-koop]');
    const knop = f && $('[data-bl-knop]', f);
    if (!knop) return;
    knop.classList.add('is-toegevoegd');
    clearTimeout(knop._t);
    knop._t = setTimeout(() => knop.classList.remove('is-toegevoegd'), 2200);
  });

  /* 2. Module "Wat het glas tegenhoudt". Zelfde formules als het ontwerp (collectie-bestanden/_scripts/bouw.py). */
  $$('[data-bl-module]').forEach(module => {
    let T = {glas: []};
    try { T = JSON.parse(module.dataset.blTekst || '{}'); } catch (e) { /* vaste teksten in de HTML */ }
    const GOLF = []; for (let w = 380; w <= 780; w += 4) GOLF.push(w);
    const BASIS_Y = 236, TOP_Y = 22;
    const DAG = [[380, 50], [400, 83], [420, 93], [440, 105], [460, 118], [480, 115], [500, 109], [520, 104], [540, 104], [560, 100],
      [580, 96], [600, 90], [620, 88], [640, 84], [660, 80], [680, 78], [700, 71], [720, 66], [740, 63], [760, 56], [780, 52]];
    const bronDag = w => { for (let i = 0; i < DAG.length - 1; i++) { const [a, va] = DAG[i], [b, vb] = DAG[i + 1]; if (w >= a && w <= b) return va + (vb - va) * (w - a) / (b - a); } return DAG[DAG.length - 1][1]; };
    const bronAvond = w => Math.exp(-0.5 * ((w - 450) / 11) ** 2) + 0.48 * Math.exp(-0.5 * ((w - 560) / (w < 560 ? 40 : 66)) ** 2);
    const norm = arr => { const mx = Math.max(...arr); return arr.map(v => v / mx); };
    const BRON = {dag: norm(GOLF.map(bronDag)), avond: norm(GOLF.map(bronAvond))};
    const gx = w => (w - 380) / 400 * 1000;
    const gy = v => BASIS_Y - v * (BASIS_Y - TOP_Y);
    const lijn = vals => 'M' + GOLF.map((w, i) => gx(w).toFixed(1) + ',' + gy(vals[i]).toFixed(1)).join(' L');
    const spec = $('.bl-spec', module);
    const padLicht = $('#bl-pad-licht', module);
    const padLijn = $('#bl-pad-lijn', module);
    const schuif = $('[data-bl-glas-schuif]', module);
    const stops = $$('.bl-glaskeuze__stops button', module);
    if (!spec || !schuif) return;
    const stand = {moment: 'avond', glas: 2};
    let nu = BRON.avond.slice();
    let anim = 0;
    const teken = vals => {
      if (!padLijn || !padLicht) return;
      const d = lijn(vals);
      padLijn.setAttribute('d', d);
      padLicht.setAttribute('d', d + ` L1000,${BASIS_Y} L0,${BASIS_Y} Z`);
    };
    const naar = doel => {
      cancelAnimationFrame(anim);
      const van = nu.slice();
      if (rustig.matches) { nu = doel; teken(nu); return; }
      const t0 = performance.now(), duur = 480;
      const stap = t => {
        const k = Math.min(1, (t - t0) / duur);
        const ez = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        nu = van.map((v, i) => v + (doel[i] - v) * ez);
        teken(nu);
        if (k < 1) anim = requestAnimationFrame(stap);
      };
      anim = requestAnimationFrame(stap);
    };
    const zet = vanMoment => {
      const {moment, glas} = stand;
      if (vanMoment) naar(BRON[moment].slice());
      spec.dataset.moment = moment;
      spec.dataset.glas = String(glas);
      schuif.value = String(glas);
      schuif.style.setProperty('--bl-schuif', (glas * 50) + '%');
      if (T.glas && T.glas[glas]) schuif.setAttribute('aria-valuetext', T.glas[glas]);
      stops.forEach((b, i) => b.setAttribute('aria-pressed', String(i === glas)));
      module.dataset.moment = moment;
      module.dataset.glas = String(glas);
    };
    $$('input[data-bl-moment]', module).forEach(r => r.addEventListener('change', () => { if (r.checked) { stand.moment = r.value; zet(true); } }));
    schuif.addEventListener('input', () => { stand.glas = Number(schuif.value); zet(false); });
    stops.forEach(b => b.addEventListener('click', () => { stand.glas = Number(b.dataset.glas); zet(false); schuif.focus({preventScroll: true}); }));
  });

  /* 3. Inklappen op de telefoon. Vanaf 700 px open en niet in te klappen. */
  const inklap = $$('details[data-bl-inklap]');
  const eersteFaq = $('.bl-faq__lijst details[open]');
  const zetInklap = () => { inklap.forEach(d => { d.open = !telefoon.matches; }); if (eersteFaq) eersteFaq.open = !telefoon.matches; };
  zetInklap();
  telefoon.addEventListener('change', zetInklap);
  inklap.forEach(d => { const s = $('summary', d); if (s) s.addEventListener('click', ev => { if (!telefoon.matches) ev.preventDefault(); }); });
  const openDoel = hash => {
    if (!hash || hash.length < 2) return;
    let doel = null;
    try { doel = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return; }
    const d = doel && (doel.matches('details') ? doel : doel.closest('details'));
    if (d && !d.open) d.open = true;
  };
  document.addEventListener('click', ev => { const a = ev.target.closest && ev.target.closest('a[href^="#"]'); if (a) openDoel(a.getAttribute('href')); });
  openDoel(location.hash);

  /* 4. Koopbalk */
  const balk = $('[data-bl-balk]');
  const kaarten = $('.bl-kaarten');
  const voet = $('.footer') || $('footer');
  if (balk && kaarten) {
    const meet = () => {
      const voorbij = kaarten.getBoundingClientRect().bottom < 0;
      const bijVoet = !!(voet && voet.getBoundingClientRect().top < innerHeight);
      balk.classList.toggle('is-zichtbaar', voorbij && !bijVoet);
    };
    let rij = 0;
    const plan = () => { cancelAnimationFrame(rij); rij = requestAnimationFrame(meet); };
    addEventListener('scroll', plan, {passive: true});
    addEventListener('resize', plan, {passive: true});
    meet();
  }
})();
